/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { CellPresenterBase } from "./CellPresenterBase";
import { CellModel } from "./CellModel";
import { TextCellModel } from "./TextCellModel";
import { ContentCellModelHelper } from "./ContentCellModelHelper";
import { TypeRegistrar, markType } from "igniteui-react-core";
/**
 * @hidden
 */
var TextHeaderCellPresenter = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(TextHeaderCellPresenter, _super);
    function TextHeaderCellPresenter(a) {
        return _super.call(this, a) || this;
    }
    Object.defineProperty(TextHeaderCellPresenter.prototype, "d", {
        get: function () {
            return this.a;
        },
        enumerable: true,
        configurable: true
    });
    TextHeaderCellPresenter.prototype.b = function (a) {
        _super.prototype.b.call(this, a);
        var b = a;
        if (a.ar) {
            if (a.aw(TextCellModel.kf)) {
                b.ie = b.kh;
                this.d.ch.setRawText(b.ie);
            }
            if (a.aw(CellModel.fz)) {
                var c = this.d.cb.l;
                if (a.a8) {
                    this.d.cb.l = false;
                }
                this.d.cb.b = a.m;
                if (a.a8) {
                    this.d.cb.l = c;
                }
            }
            if (a.aw(CellModel.f0)) {
                var d = this.d.cb.l;
                if (a.a8) {
                    this.d.cb.l = false;
                }
                this.d.cb.a0 = a.kc;
                if (a.a8) {
                    this.d.cb.l = d;
                }
            }
            if (a.av("IsColumnOptionsEnabled")) {
                var e = b.kq;
                if (e) {
                    e = this.e();
                }
                this.d.cd = e;
                this.d.cf.setRawStyleProperty("display", e ? "inline-block" : "none");
                this.a.bs(a.f8, (a.fh + a.fj + a.d6 + a.d9));
            }
            if (a.av("SortIndicatorStyle")) {
                this.d.cb.f = b.ko;
            }
            if (a.av("ColumnOptionsIconAlignment")) {
                this.d.b5 = b.kk;
            }
            if (a.av("ColumnOptionsIconBehavior")) {
                this.d.b7 = b.km;
            }
            if (a.av("ColumnOptionsIconColor")) {
                this.d.b9.bp = b.k2;
            }
            ContentCellModelHelper.a(this.a.w, b, this.a.z, this.d.ch, this.a);
        }
    };
    TextHeaderCellPresenter.prototype.e = function () {
        return TypeRegistrar.isRegistered("IgxGridColumnOptionsComponent");
    };
    TextHeaderCellPresenter.$t = markType(TextHeaderCellPresenter, 'TextHeaderCellPresenter', CellPresenterBase.$);
    return TextHeaderCellPresenter;
}(CellPresenterBase));
export { TextHeaderCellPresenter };
//# sourceMappingURL=TextHeaderCellPresenter.js.map
